import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const deleteProduct = unaryRpc({
  name: "deleteProduct",
  input: z.object({ id: zExt.objectId() }),

  output: z.object({ success: z.boolean(), deletedId: zExt.objectId() }),
});
